import { createSelector } from '@ngrx/store';
import { MenuState } from './menu.reducer';

// The root "AppState" only has { menu: MenuState } for simplicity
export interface AppState {
  menu: MenuState;
}

export const selectMenuState = (state: AppState) => state.menu;

export const selectMenuItems = createSelector(
  selectMenuState,
  (menuState) => menuState.menuItems
);

export const selectMenuLoading = createSelector(
  selectMenuState,
  (menuState) => menuState.loading
);

export const selectMenuError = createSelector(
  selectMenuState,
  (menuState) => menuState.error
);